import React from "react";
import styled from "styled-components";

const StreamingDetails = ({
  isUrlSaved,
  url,
  setUrl,
  handleSaveUrl,
  streamerName,
  onDeleteClick,
  isStreamer,
}) => {
  if (!isUrlSaved) {
    return (
      <Block>
        <Label>URL del VOD</Label>
        <InputRow>
          <UrlInput
            type="text"
            placeholder="https://..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
          <SaveBtn onClick={handleSaveUrl}>Guardar</SaveBtn>
        </InputRow>
      </Block>
    );
  }

  return (
    <Block>
      <VodText>
        Partida casteada por <StreamerName>{streamerName}</StreamerName>
      </VodText>
      <BtnRow>
        <ActionBtn onClick={() => window.open(url, "_blank")}>Ver VOD</ActionBtn>
        {isStreamer && (
          <ActionBtn $danger onClick={onDeleteClick}>Borrar</ActionBtn>
        )}
      </BtnRow>
    </Block>
  );
};

const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Label = styled.span`
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-fg-muted);
`;

const InputRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const UrlInput = styled.input`
  flex: 1;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 0.5rem 0.75rem;
  font-family: var(--v-font-mono);
  font-size: 12px;
  color: var(--v-fg);
  outline: none;

  &:focus {
    border-color: var(--v-mint);
  }

  &::placeholder {
    color: var(--v-fg-muted);
    opacity: 0.5;
  }
`;

const SaveBtn = styled.button`
  background: var(--v-mint);
  color: #000;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 24px;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

const VodText = styled.p`
  font-family: var(--v-font-body);
  font-size: 13px;
  color: var(--v-fg);
  margin: 0;
`;

const StreamerName = styled.span`
  font-weight: 600;
  color: var(--v-mint);
`;

const BtnRow = styled.div`
  display: flex;
  gap: 0.5rem;
`;

const ActionBtn = styled.button`
  background: transparent;
  border: 1px solid ${({ $danger }) => ($danger ? "rgba(255,75,75,0.3)" : "rgba(255,255,255,0.12)")};
  color: ${({ $danger }) => ($danger ? "#ff4b4b" : "var(--v-fg-muted)")};
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.4rem 0.85rem;
  border-radius: 24px;
  cursor: pointer;
  transition: background var(--v-transition);

  &:hover {
    background: rgba(255, 255, 255, 0.04);
  }
`;

export default StreamingDetails;
